import React from 'react';
import { Award, Briefcase, GraduationCap, Target, Linkedin } from 'lucide-react';

const Founder = () => {
  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-orange-400 font-semibold mb-3">Leadership</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Meet Our Founder</h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Driven by innovation, guided by expertise, committed to your success
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-gray-900 border border-gray-700 rounded-2xl overflow-hidden">
            <div className="grid md:grid-cols-5 gap-8 p-8 md:p-12">
              {/* Photo */}
              <div className="md:col-span-2">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-orange-500/20 to-amber-500/20 rounded-2xl blur-2xl"></div>
                  <img
                    src="https://customer-assets.emergentagent.com/job_site-accelerator-2/artifacts/zgvl3o6u_Nagesh%20Image.jpeg"
                    alt="Nagesh Reddy - Founder & CEO"
                    className="relative w-full h-auto rounded-2xl border-2 border-orange-500/30 object-cover shadow-2xl"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="md:col-span-3 space-y-6">
                <div>
                  <h3 className="text-3xl font-bold text-white mb-2">Nagesh Reddy</h3>
                  <p className="text-xl bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent font-semibold">
                    Founder & CEO
                  </p>
                </div>

                <p className="text-gray-300 leading-relaxed">
                  With a unique blend of technical expertise and entrepreneurial vision, Nagesh leads AION WISE's 
                  mission to democratize AI technology for businesses worldwide. His passion lies in transforming 
                  complex technological challenges into scalable, innovative solutions that drive real business value.
                </p>

                {/* Education & Credentials */}
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <GraduationCap className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white font-semibold">Master of Science in Engineering Management</p>
                      <p className="text-gray-400 text-sm">Northeastern University</p>
                      <p className="text-gray-500 text-sm">Specialized in Finance & Technology Business Management</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Award className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white font-semibold">Post Graduate in Technological Entrepreneurship</p>
                      <p className="text-gray-400 text-sm">Specialized in Enterprise Growth & AI Innovation</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Briefcase className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white font-semibold">Former Cloud FinOps Lead</p>
                      <p className="text-gray-400 text-sm">Cona Services (Coca-Cola North America)</p>
                      <p className="text-gray-500 text-sm">Led technology business management & cloud cost optimization initiatives</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <Target className="w-6 h-6 text-orange-400 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-white font-semibold">Core Expertise</p>
                      <p className="text-gray-400 text-sm">AI Strategy, Cloud Architecture, Business Transformation, Technology Leadership</p>
                    </div>
                  </div>
                </div>

                {/* Quote */}
                <div className="bg-gradient-to-r from-orange-600/10 to-amber-600/10 border-l-4 border-orange-500 rounded-r-lg p-4 mt-6">
                  <p className="text-gray-300 italic">
                    "At AION WISE, we don't just build AI solutions—we partner with businesses to create 
                    transformative experiences that drive measurable results. Every project is an opportunity 
                    to push boundaries and deliver excellence."
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Why Work With Nagesh */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 hover:border-orange-500 transition-all">
              <div className="text-orange-400 text-3xl font-bold mb-2">25+</div>
              <p className="text-white font-semibold mb-1">Projects Delivered</p>
              <p className="text-gray-400 text-sm">Successfully led and executed AI initiatives across industries</p>
            </div>
            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 hover:border-orange-500 transition-all">
              <div className="text-orange-400 text-3xl font-bold mb-2">Fortune 100</div>
              <p className="text-white font-semibold mb-1">Enterprise Experience</p>
              <p className="text-gray-400 text-sm">Proven track record with global industry leaders</p>
            </div>
            <div className="bg-gray-900 border border-gray-700 rounded-xl p-6 hover:border-orange-500 transition-all">
              <div className="text-orange-400 text-3xl font-bold mb-2">100%</div>
              <p className="text-white font-semibold mb-1">Client Satisfaction</p>
              <p className="text-gray-400 text-sm">Committed to excellence in every engagement</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
